import type { ReactNode } from 'react'

import { PUSH_EVENT_LABEL } from '@/src/features/notification/models/notification.constants'
import { PushRequest } from '@/src/features/notification/ui/components/PushRequest'
import { TEST_ID } from '@/src/general/constants/testId'

import { SettingsCardSwitchInput } from '../SettingsCardSwitchInput'
import type { TSettingsCardGeneralPushSwitchProps } from './SettingsCardGeneralPushSwitch.types'

export const SettingsCardGeneralPushSwitch = ({
  push,
  pushDisabled,
  onPushChange,
}: TSettingsCardGeneralPushSwitchProps): ReactNode => (
  <PushRequest eventLabel={PUSH_EVENT_LABEL.SETTINGS_PAGE} onPermissionChanged={() => {}}>
    {({ onTrigger }) => (
      <SettingsCardSwitchInput.Push
        testID={TEST_ID.SETTINGS.COMPONENTS.CARD_GENERAL_SWITCH_INPUT.PUSH}
        value={push}
        onValueChange={() => {
          onPushChange(!push)
          if (!push) {
            onTrigger()
          }
        }}
        disabled={pushDisabled}
      />
    )}
  </PushRequest>
)
